/**
 * Callable del wizard L03. Isolato cosi' i test possono mockare il
 * caricamento del registro e la classificazione degli errori senza
 * montare Firebase.
 */

import { httpsCallable } from 'firebase/functions';
import type { DocumentoLegale } from '@shared/legal/documento-legale.types';
import { pazienteFunctions } from '../firebase-paziente';

export const PAYLOAD_SHAPE_ERROR_MESSAGE =
  'Il modulo è in aggiornamento. Riprova fra qualche minuto: il link resta valido.';

/**
 * Errore di FORMA del payload (Zod della CF).
 *
 * Finestra di deploy Functions-prima-di-hosting:paziente: il portale
 * vecchio manda `consensi`+`signature`, la CF nuova esige `documenti[]`
 * e risponde `invalid-argument`. Il match e' sul codice, non sul testo
 * del messaggio: se il testo cambia, il comportamento resta. Un falso
 * positivo su un altro errore di validazione mostra un messaggio piu'
 * gentile, ed e' innocuo.
 */
export function isPayloadShapeError(err: unknown): boolean {
  if (typeof err !== 'object' || err === null) return false;
  const rec = err as { code?: unknown };
  const code = typeof rec.code === 'string' ? rec.code : '';
  return code === 'functions/invalid-argument' || code === 'invalid-argument';
}

export async function loadDocumentiLegaliAttivi(): Promise<DocumentoLegale[]> {
  const fn = httpsCallable<Record<string, never>, { documenti: DocumentoLegale[] }>(
    pazienteFunctions,
    'getDocumentiLegaliAttivi'
  );
  const res = await fn({});
  const documenti = res.data.documenti;
  if (!Array.isArray(documenti) || documenti.length === 0) {
    throw new Error('registro-vuoto');
  }
  return documenti;
}
